import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostSyncAzureActiveDirectoryCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostSyncAzureActiveDirectoryCommandService],
  exports: []
})
export class PostSyncAzureActiveDirectoryCommandServiceModule { }
